import { BaseModel } from '@/_models/base'
import { requests } from '@/_helpers/requests'

const route = locationId => `partner-portal/locations/${locationId}/blocked-day-patterns`

export class LocationRecurringBlock extends BaseModel {
  constructor(id, locationId, month, day, name) {
    super()

    this.id = id
    this.locationId = locationId
    this.month = month
    this.day = day
    this.name = name
  }

  // API sends the date as "MM-DD"; the UI works with numeric month/day.
  fromJSON(json) {
    const block = Object.assign(new LocationRecurringBlock(), json)
    if (json.monthDay) {
      const [month, day] = json.monthDay.split('-').map(Number)
      if (Number.isInteger(month) && Number.isInteger(day)) {
        block.month = month
        block.day = day
      }
    }
    return block
  }

  // Numeric month/day -> "MM-DD".
  toMonthDay() {
    const pad = n => String(n).padStart(2, '0')
    return `${pad(this.month)}-${pad(this.day)}`
  }

  create() {
    const payload = { name: this.name, patternType: 'annual', monthDay: this.toMonthDay() }
    return requests.post(route(this.locationId), payload).then(response => {
      const data = (response && response.data) || {}
      if (!data.id) {
        throw new Error('blocked-day-pattern create returned no id')
      }
      this.id = data.id
      return this
    })
  }

  // Only name + monthDay are mutable; patternType is fixed.
  update() {
    const payload = { name: this.name, monthDay: this.toMonthDay() }
    return requests.put(`${route(this.locationId)}/${this.id}`, payload).then(() => this)
  }

  deleteThis() {
    return requests.deleteReq(`${route(this.locationId)}/${this.id}`)
  }
}

export const cLocationRecurringBlock = new LocationRecurringBlock()
